import { render, staticRenderFns } from "./SelfEShopGroup.vue?vue&type=template&id=28e5d2b3&scoped=true"
import script from "./SelfEShopGroup.vue?vue&type=script&lang=js"
export * from "./SelfEShopGroup.vue?vue&type=script&lang=js"
import style0 from "./SelfEShopGroup.vue?vue&type=style&index=0&id=28e5d2b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5d2b3",
  null
  
)

export default component.exports